import { Button, Card, Modal } from "react-bootstrap"
import { ProjectTask } from "../../models/project-task"
import { formatDate } from "../../utils/formatDate";
import styles from "../../styles/ProjectTaskInfo.module.css"
import StatusCard from "./StatusCard";
import * as ProjectTaskFilesApi from "../../network/project-task-files-api";
import { useState } from "react";
import ProjectTaskChangeStatusDialog from "./ProjectTaskChangeStatusDialog";

interface ProjectTaskInfoProps {
    projectTask: ProjectTask,
    onDismiss: (updatedTask: ProjectTask) => void,
}

const ProjectTaskInfo = ({projectTask, onDismiss}: ProjectTaskInfoProps) => {
    const [showChangeStatusDialog, setShowChangeStatusDialog] = useState(false);
    const [newStatus, setNewStatus] = useState(projectTask.status);
    const [projectTaskData, setProjectTaskData] = useState(projectTask);

    const updateTask = (task: ProjectTask) => {
        setProjectTaskData(task);
        setShowChangeStatusDialog(false);
    }

    const downloadFile = () => {
        ProjectTaskFilesApi.fetchProjectTaskFile({taskId: projectTaskData._id});
    }
    
    return (
        <Modal show onHide={() => {onDismiss(projectTaskData)}}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {projectTaskData?.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card className={`mb-3 ${styles.TaskDescription}`}>
                    <p>{projectTaskData?.text}</p>
                </Card>
                <Card className={`mb-3 ${styles.TaskStatus}`}>
                    <div>{"Статус:"}</div>
                    <StatusCard status={projectTaskData.status}/>
                </Card>
                <Card className={`mb-3 ${styles.TaskDeadline}`}>
                    <div>{"Дедлайн:"}</div>
                    <div>{formatDate(projectTaskData.deadline)}</div>
                </Card>
                {(projectTaskData?.statusDescription && !showChangeStatusDialog) &&
                    <>
                        <Card className={`mb-3 ${styles.TaskStatusDescription}`}>
                            <Card.Header>
                                Описание изменения статуса
                            </Card.Header>
                            <Card.Body className={styles.statusDescription}>
                                {projectTaskData.statusDescription}
                            </Card.Body>
                        </Card>
                        <Button onClick={downloadFile}>
                            Скачать закреплённый отчёт
                        </Button>
                    </>
                }
            </Modal.Body>
            {(projectTaskData.status === "В работе" && !showChangeStatusDialog) &&
                <Modal.Footer className={styles.TaskFooter}>
                    <Button onClick={() => {setNewStatus("Нужна помощь"); setShowChangeStatusDialog(true);}} variant="warning" className={styles.NeedHelpButton}>
                        Нужна помощь
                    </Button>
                    <Button onClick={() => {setNewStatus("Готово"); setShowChangeStatusDialog(true);}} variant="success" className={styles.DoneButton}>
                        Готово
                    </Button>
                </Modal.Footer>
            }
            {(projectTaskData.status === "Нужна помощь" && !showChangeStatusDialog) &&
                <Modal.Footer className={styles.TaskFooter}>
                    <Button onClick={() => {setNewStatus("В работе"); setShowChangeStatusDialog(true);}} className={styles.NeedHelpButton}>
                        В работе
                    </Button>
                    <Button onClick={() => {setNewStatus("Готово"); setShowChangeStatusDialog(true);}} variant="success" className={styles.DoneButton}>
                        Готово
                    </Button>
                </Modal.Footer>
            }
            {(projectTaskData.status === "Готово" && !showChangeStatusDialog) &&
                <Modal.Footer className={styles.TaskFooter}>
                    <Button onClick={() => {setNewStatus("Нужна помощь"); setShowChangeStatusDialog(true);}} variant="warning" className={styles.NeedHelpButton}>
                        Нужна помощь
                    </Button>
                    <Button onClick={() => {setNewStatus("В работе"); setShowChangeStatusDialog(true);}} className={styles.DoneButton}>
                        В работе
                    </Button>
                </Modal.Footer>
            }
            {showChangeStatusDialog&& 
                <ProjectTaskChangeStatusDialog
                    task={projectTaskData}
                    newStatus={newStatus}
                    onStatusUpdated={updateTask}
                />
            }
        </Modal>
    );
}

export default ProjectTaskInfo;